import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { Alert, Snackbar } from '@mui/material'
import axios from 'axios'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, useRoutes } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { SWRConfig } from 'swr'
import '~/src/libs/i18next/config'
import { swrConfig } from './config/swr'
import { ProvideAuth } from './hooks/useAuth'
import { useMessage } from '~/src/hooks'
import reportWebVitals from './reportWebVitals'
import { routes } from './routes'
import { theme } from './theme'
import './style.css'

axios.defaults.withCredentials = true

const app = document.getElementById('app')

export const ReactApp = () => {
  const element = useRoutes(routes)
  const { isOpen, successMessage, errorMessage, handleClose } = useMessage()

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {element}
      <Snackbar
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ml: 16 }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={isOpen}
        autoHideDuration={1500}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={successMessage ? 'success' : 'error'}
          sx={{ width: '500px' }}
        >
          {successMessage ? successMessage : errorMessage}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <ProvideAuth>
        <BrowserRouter>
          <SWRConfig value={swrConfig}>
            <ReactApp />
          </SWRConfig>
        </BrowserRouter>
      </ProvideAuth>
    </RecoilRoot>
  </React.StrictMode>,
  app
)

reportWebVitals()
